export default {
  namespaced      : true,
  
  state           : {
    isOpenModal     : false,
    isFreezModal    : false,
    isSubmitLoading : false,
    behaviour       : 'deleteNote', // or deleteNoteComment
    
    parkNote        : null,
    parkNoteComment : null,
  },

  mutations       : {
    setIsOpenModal(state, value){
      state.isOpenModal = value;
    },

    setIsFreezModal(state, value){
      state.isFreezModal = value;
    },

    setIsSubmitLoading(state, value){
      state.isSubmitLoading = value;
    },

    setBehaviour(state, value){
      state.behaviour = value;
    },

    setParkNote(state, data){
      state.parkNote = data;
    },

    setParkNoteComment(state, data){
      state.parkNoteComment = data;
    },

    resetStore(state){
      state.isOpenModal     = false;
      state.isFreezModal    = false;
      state.isSubmitLoading = false;
      state.behaviour       = 'deleteNote';
      state.parkNote        = null;
      state.parkNoteComment = null;
    }
  },

  actions         : {
    updateModal(context, payload){
      if(typeof payload.isOpen !== 'undefined'){
        context.commit('setIsOpenModal', payload.isOpen);
      }
      
      if(typeof payload.isFreezModal !== 'undefined'){
        context.commit('setIsFreezModal', payload.isFreezModal);
      }

      if(typeof payload.isSubmitLoading !== 'undefined'){
        context.commit('setIsSubmitLoading', payload.isSubmitLoading);
      }

      if(typeof payload.behaviour !== 'undefined'){
        context.commit('setBehaviour', payload.behaviour);
      }

      if(typeof payload.parkNote !== 'undefined'){
        context.commit('setParkNote', payload.parkNote);
      }

      if(typeof payload.parkNoteComment !== 'undefined'){
        context.commit('setParkNoteComment', payload.parkNoteComment);
      }
    },

    resetStore(context){
      context.commit('resetStore');
    }
  }
}
